export const getToken = (): any => {
    if (typeof window === 'undefined' || !localStorage.getItem('token')) {
        return null;
    }
    return {
        token: localStorage.getItem('token'), 
        sessionId: localStorage.getItem('sessionId')
    };
};